(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobai-contact-buttons"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mobai-contact-buttons')) {
    customElements.define('mobai-contact-buttons', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized) return;
        this.dataset.initialized = 'true';
        const details = this.querySelector('details');
        const summary = this.querySelector('summary');
        this.querySelector('.mobai-contact__close')?.addEventListener('click', () => { details.open = false; summary.focus(); });
        this.addEventListener('keydown', event => { if (event.key === 'Escape' && details?.open) { details.open = false; summary.focus(); } });
        this.querySelector('.mobai-contact__copy')?.addEventListener('click', async event => {
          const button = event.currentTarget;
          const number = this.querySelector('input');
          const status = this.querySelector('[role="status"]');
          try { await navigator.clipboard.writeText(number.value); status.textContent = button.dataset.success; }
          catch { number.focus(); number.select(); status.textContent = button.dataset.failure; }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
